window.onscroll = scrolled;

function scrolled(){
  document.querySelector("recently-viewed-popup").style.display = "none";
}


const onScrollStop = callback => {
  let isScrolling;
  window.addEventListener(
    'scroll',
    e => {
      clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        callback();
      }, 150);
    },
    false
  );
};

onScrollStop(() => {
    document.querySelector("recently-viewed-popup").style.display = "block";
});